// extracted by mini-css-extract-plugin
export var post = "blog-module--post--yRojc";
export var posts = "blog-module--posts--aO8SG";